import * as React from 'react'

export const CircleAlertIcon = ({
  className,
  fill = 'none',
}: {
  className?: string
  fill: string
}) => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7 12.5C4.84375 12.5 2.875 11.375 1.79688 9.5C0.71875 7.64844 0.71875 5.375 1.79688 3.5C2.875 1.64844 4.84375 0.5 7 0.5C9.13281 0.5 11.1016 1.64844 12.1797 3.5C13.2578 5.375 13.2578 7.64844 12.1797 9.5C11.1016 11.375 9.13281 12.5 7 12.5ZM7 3.5C6.67188 3.5 6.4375 3.75781 6.4375 4.0625V6.6875C6.4375 7.01562 6.67188 7.25 7 7.25C7.30469 7.25 7.5625 7.01562 7.5625 6.6875V4.0625C7.5625 3.75781 7.30469 3.5 7 3.5ZM6.25 8.75C6.25 9.17188 6.57812 9.5 7 9.5C7.39844 9.5 7.75 9.17188 7.75 8.75C7.75 8.35156 7.39844 8 7 8C6.57812 8 6.25 8.35156 6.25 8.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
